import React from "react";
import Upstander from "../../../images/Upstander.jpg";
import PageLayout from "../../ui/PageLayout";
import PageHero from "../../ui/PageHero";
import CategoryCardGrid from "../../ui/CategoryCardGrid";

const hangoutCards = [
  { to: "./upstander", image: Upstander, title: "Upstander - The Power of One" },
];

const Hangouts = () => (
  <PageLayout>
    <PageHero title="Kindness Hangouts" light />
    <CategoryCardGrid cards={hangoutCards} columns={1} />
  </PageLayout>
);

export default Hangouts;
